module.exports = __webpack_public_path__ + "img/2012-12-14 18.19.27.cad7f952.jpg";